<script>
  import {createEventDispatcher} from 'svelte';
  import {fade} from 'svelte/transition';
  import {sd} from '@/da/sd';
  import Button from '@/widgets/Button.svelte';
  import {dialogStatus$} from './stream';

  export let content = '';

  const dispatch = createEventDispatcher();

  function handleCloseClick() {
    dispatchClose();
  }

  function handleCloseClickFun(btnDetail, index) {
    return function () {
      dispatchClose();
      sd.track(`sensors_image_dialog_button${index}_click`, {ui_position: 'sensors-date-popups', $element_content: btnDetail.btnTitle});
    };
  }

  function handleLinkClickFun(btnDetail, index) {
    return function () {
      window.open(btnDetail.webLink, '_blank');
      sd.track(`sensors_image_dialog_button${index}_click`, {ui_position: 'sensors-date-popups', $element_content: btnDetail.btnTitle});
      dispatchClose();
    };
  }

  function dispatchClose() {
    dispatch('close');
    dialogStatus$.next(false);
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 8000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 8000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    white-space: pre-wrap;
    word-break: break-all;
    color: #141414;
    font-weight: 700;
  }
  .content {
    width: 480px;
    background: #FFF;
    box-sizing: border-box;
  }
  .text {
    max-height: 348px;
    color: #141414;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .close {
    color: #858585;
  }
  .avg {
    flex: 1;
  }
  .btns {
    flex-direction: row-reverse;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
  }
  .btns :global(.btn1) {
    background: #141414;
    color: #fff;
    border-radius: 99px;
    border-color: #141414;
    height: 44px;
    line-height: 42px;
    font-weight: 700;
  }
  .btns :global(.btn2) {
    background: #EBEBEB;
    color: #141414;
    border-radius: 99px;
    border-color: #EBEBEB;
    height: 44px;
    margin-left: 0;
  }
  .fw4 {
    font-weight: 700;
  }
  @media screen and (max-width: 640px) {
    .content {
      padding: 24px;
      width: 80%;
    }
  }
</style>

<div class="modal-mask" in:fade={{duration: 100}} out:fade={{duration: 100}}>
  <div class="container">
    <div class="content pr br12 pv24 ph24">
      <div class="df aic jcsb">
        <div class="f1 title lh24 f20 fw4">{content.title}</div>
        <i class="close iconfont f20 cp" on:click={handleCloseClick}>&#xe6bf;</i>
      </div>
      <div class="mt24 ovh">
        <div class="text lh22 f16 fw1">{@html content.content}</div>
      </div>
      <div class="btns df fww pt24">
        {#if content.btn1}
          <Button
            class="f1 mt0 wsn avg f16 fw4 btn1"
            newRadius
            type="primary"
            on:click={content.btn1.buttonAction === 'CLOSE' ? handleCloseClickFun(content.btn1, 1) : handleLinkClickFun(content.btn1, 1)}
          >
            {content.btn1.btnTitle}
          </Button>
        {/if}
        {#if content.btn2}
          <Button
            class="f1 wsn avg f16 fw2 btn2"
            newRadius
            type="primary"
            on:click={content.btn2.buttonAction === 'CLOSE' ? handleCloseClickFun(content.btn2, 2) : handleLinkClickFun(content.btn2, 2)}
          >
            {content.btn2.btnTitle}
          </Button>
        {/if}
      </div>
    </div>
  </div>
</div>
